import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { Observable, retry, Subject } from 'rxjs';
import { CancelacionesFraudesService } from '../../pages/administracion/cancelaciones-fraude/cancelaciones-fraudes.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private http = inject(HttpClient);
  private settingsService = inject(SettingsService);
  private cancelacionesFraudesService = inject(CancelacionesFraudesService);
  private _userId: string | null = null;

  private _isSessionIniciada = false;

  // Subject para emisiones
  private cantidadModulosSubject = new Subject<number>();

  // Observable público para suscripciones
  public cantidadModulos$: Observable<number> = this.cantidadModulosSubject.asObservable();

  /**
   * Almacena la sesion en memoria
   * @param data datos de sesion de usuario
   */
  setToken(token: string) {
    this._isSessionIniciada = true;
    localStorage.setItem('session', token);
  }

  get isSessionIniciada() {
    return this._isSessionIniciada;
  }

  /**
   * Cierra la sesion actual y redirige a la pantalla de login del
   * Back Office.
   */
  logout() {
    this._isSessionIniciada = false;
    localStorage.clear();
    this.cancelacionesFraudesService.clearPermisos();
    window.location.href = this.settingsService.LOGIN_URL;
  }

  /**
   * Obtiene el token de sesion actual.
   *
   * @returns token de sesion actual si existe, null en caso contrario.
   */
  getAccessToken() {
    const token = localStorage.getItem('session');
    if (token) {
      return token;
    } else {
      return null;
    }
  }

  /**
   * Verifica si el token de sesion actual es valido.
   * Si el token es valido, devuelve un objeto con la informacion
   * de sesion actual. Si el token no es valido, devuelve un objeto
   * con un mensaje de error.
   *
   * @param moduloId Identificador del modulo a verificar.
   * @returns Observale que contiene la informacion de sesion actual.
   */
  validarToken(moduloId: number): Observable<any> {
    return this.http.post(`${this.settingsService.URL_VALIDACION_TOKEN}/login/actualizar_token`, { moduloId });
  }

  get userId(): null | string {
    return this._userId;
  }

  set userId(userId: string) {
    this._userId = userId;
  }

  actualizarCantidadModulos(cantidad: number): void {
    this.cantidadModulosSubject.next(cantidad);
  }

  getMenuList() {
    return this.http.post(`${this.settingsService.URL_BASE}usuario/permisos`, { userId: this.userId }).pipe(
      retry(3), // Intenta la petición hasta 3 veces si falla
    );
  }
}
